import React, { useEffect, useState, useCallback } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import axios from '../../axios/axiosconf';
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Swal from "sweetalert2";

function CrearRDAExterna() {
    const history = useHistory();
    const queryParams = useLocation().search;
    const pacienteIdParam = new URLSearchParams(queryParams).get('pacienteId');
    const evolucionIdParam = new URLSearchParams(queryParams).get('evolucionId');

    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [paciente, setPaciente] = useState(null);
    const [evolucion, setEvolucion] = useState(null);
    const [userConfig, setUserConfig] = useState(null);

    // Secciones colapsables
    const [seccionPrestador, setSeccionPrestador] = useState(true);
    const [seccionPaciente, setSeccionPaciente] = useState(true);
    const [seccionConsulta, setSeccionConsulta] = useState(true);
    const [seccionAntecedentes, setSeccionAntecedentes] = useState(false);
    const [seccionDiagnosticos, setSeccionDiagnosticos] = useState(true);
    const [seccionMedicamentos, setSeccionMedicamentos] = useState(false);
    const [seccionProcedimientos, setSeccionProcedimientos] = useState(false);
    const [seccionOtrasTecnologias, setSeccionOtrasTecnologias] = useState(false);
    const [seccionIncapacidad, setSeccionIncapacidad] = useState(false);
    const [seccionProfesional, setSeccionProfesional] = useState(true);

    // ========== DATOS DEL FORMULARIO ==========
    
    // Prestador
    const [codigoPrestador, setCodigoPrestador] = useState('');
    
    // Entidad responsable (EPS)
    const [codigoEps, setCodigoEps] = useState('');
    const [nombreEps, setNombreEps] = useState('');

    // Paciente (pre-llenado desde datos existentes)
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [codigoPaisNacionalidad, setCodigoPaisNacionalidad] = useState('CO');
    const [nombrePaisNacionalidad, setNombrePaisNacionalidad] = useState('Colombia');
    const [sexoBiologico, setSexoBiologico] = useState('');
    const [identidadGenero, setIdentidadGenero] = useState('');
    const [etnia, setEtnia] = useState('');
    const [comunidadEtnica, setComunidadEtnica] = useState('');
    const [categoriaDiscapacidad, setCategoriaDiscapacidad] = useState('');
    const [codigoOcupacion, setCodigoOcupacion] = useState('');
    const [nombreOcupacion, setNombreOcupacion] = useState('');
    const [codigoPaisResidencia, setCodigoPaisResidencia] = useState('CO');
    const [nombrePaisResidencia, setNombrePaisResidencia] = useState('Colombia');
    const [codigoMunicipioResidencia, setCodigoMunicipioResidencia] = useState('');
    const [nombreMunicipioResidencia, setNombreMunicipioResidencia] = useState('');
    const [zonaResidencia, setZonaResidencia] = useState('');

    // Datos de la Consulta Externa
    const [fechaHoraInicio, setFechaHoraInicio] = useState('');
    const [fechaHoraFin, setFechaHoraFin] = useState('');
    const [modalidadAtencion, setModalidadAtencion] = useState('01'); // 01: Intramural por defecto
    const [grupoServicios] = useState('01'); // 01: Consulta Externa (fijo)
    const [entornoAtencion, setEntornoAtencion] = useState('05'); // 05: Institucional por defecto
    const [viaIngreso, setViaIngreso] = useState('');
    const [causaAtencion, setCausaAtencion] = useState('');

    // Antecedentes de salud - Alergias (array)
    const [alergias, setAlergias] = useState([]);
    const [nuevaAlergiaTipo, setNuevaAlergiaTipo] = useState('');
    const [nuevaAlergiaNombre, setNuevaAlergiaNombre] = useState('');

    // Antecedentes de salud - Factores de riesgo (array)
    const [factoresRiesgo, setFactoresRiesgo] = useState([]);
    const [nuevoFactorTipo, setNuevoFactorTipo] = useState('');
    const [nuevoFactorNombre, setNuevoFactorNombre] = useState('');

    // Antecedentes familiares
    const [antecedenteFamiliarCie10, setAntecedenteFamiliarCie10] = useState('');
    const [antecedenteFamiliarCie11, setAntecedenteFamiliarCie11] = useState('');
    const [parentescoAntecedente, setParentescoAntecedente] = useState('');

    // Diagnósticos
    const [diagnosticoPrincipalCie10, setDiagnosticoPrincipalCie10] = useState('');
    const [nombreDiagnosticoPrincipal, setNombreDiagnosticoPrincipal] = useState('');
    const [tipoDiagnosticoPrincipal, setTipoDiagnosticoPrincipal] = useState('02'); // 02: Confirmado nuevo
    const [diagnosticoPrincipalCie11, setDiagnosticoPrincipalCie11] = useState('');
    const [terminoDiagnosticoCie11, setTerminoDiagnosticoCie11] = useState('');
    const [diagnosticosRelacionados, setDiagnosticosRelacionados] = useState([]);
    const [condicionDestino, setCondicionDestino] = useState('');
    const [codigoPrestadorRemision, setCodigoPrestadorRemision] = useState('');

    // Medicamentos ordenados (array)
    const [medicamentos, setMedicamentos] = useState([]);

    // Procedimientos ordenados (array)
    const [procedimientos, setProcedimientos] = useState([]);

    // Otras tecnologías ordenadas (array)
    const [otrasTecnologias, setOtrasTecnologias] = useState([]);

    // Datos incapacidad
    const [alcanceIncapacidad, setAlcanceIncapacidad] = useState('');
    const [diasIncapacidad, setDiasIncapacidad] = useState('');
    const [diasLicenciaMaternidad, setDiasLicenciaMaternidad] = useState('');

    // Profesional de salud
    const [tipoDocumentoProfesional, setTipoDocumentoProfesional] = useState('');
    const [numeroDocumentoProfesional, setNumeroDocumentoProfesional] = useState('');

    // Documento soporte PDF (opcional)
    const [documentoPdf, setDocumentoPdf] = useState(null);

    // ========== CATÁLOGOS ==========
    const tiposDocumento = [
        { codigo: 'CC', nombre: 'Cédula de Ciudadanía' },
        { codigo: 'CE', nombre: 'Cédula de Extranjería' },
        { codigo: 'PA', nombre: 'Pasaporte' },
        { codigo: 'RC', nombre: 'Registro Civil' },
        { codigo: 'TI', nombre: 'Tarjeta de Identidad' },
        { codigo: 'AS', nombre: 'Adulto sin identificar' },
        { codigo: 'MS', nombre: 'Menor sin identificar' },
        { codigo: 'NV', nombre: 'Certificado Nacido Vivo' },
        { codigo: 'PE', nombre: 'Permiso Especial de Permanencia' },
        { codigo: 'PT', nombre: 'Permiso por Protección Temporal' },
    ];

    const sexosBiologicos = [
        { codigo: 'M', nombre: 'Masculino' },
        { codigo: 'F', nombre: 'Femenino' },
        { codigo: 'I', nombre: 'Indeterminado' },
    ];

    const modalidadesAtencion = [
        { codigo: '01', nombre: 'Intramural' },
        { codigo: '02', nombre: 'Extramural unidad móvil' },
        { codigo: '03', nombre: 'Extramural domiciliaria' },
        { codigo: '04', nombre: 'Extramural jornada de salud' },
        { codigo: '05', nombre: 'Extramural (atención pre hospitalaria o transporte asistencial)' },
        { codigo: '06', nombre: 'Telemedicina interactiva' },
        { codigo: '07', nombre: 'Telemedicina no interactiva' },
        { codigo: '08', nombre: 'Telemedicina - Telexperticia' },
        { codigo: '09', nombre: 'Telemedicina - Telemonitoreo' },
    ];

    const entornosAtencion = [
        { codigo: '01', nombre: 'Hogar' },
        { codigo: '02', nombre: 'Comunitario' },
        { codigo: '03', nombre: 'Escolar' },
        { codigo: '04', nombre: 'Laboral' },
        { codigo: '05', nombre: 'Institucional' },
    ];

    const tiposAlergia = [
        { codigo: '01', nombre: 'Medicamento' },
        { codigo: '02', nombre: 'Alimento' },
        { codigo: '03', nombre: 'Sustancia del ambiente' },
        { codigo: '04', nombre: 'Sustancia que entra en contacto con la piel' },
        { codigo: '05', nombre: 'Picadura de insectos' },
        { codigo: '06', nombre: 'Otra' },
    ];

    const tiposFactorRiesgo = [
        { codigo: '01', nombre: 'Químicos' },
        { codigo: '02', nombre: 'Físicos' },
        { codigo: '03', nombre: 'Biomecánicos' },
        { codigo: '04', nombre: 'Psicosociales' },
        { codigo: '05', nombre: 'Biológicos' },
        { codigo: '06', nombre: 'Otro' },
    ];

    const parentescos = [
        { codigo: '01', nombre: 'Padres' },
        { codigo: '02', nombre: 'Hermanos' },
        { codigo: '03', nombre: 'Tíos' },
        { codigo: '04', nombre: 'Abuelos' },
    ];

    const tiposDiagnostico = [
        { codigo: '01', nombre: 'Impresión diagnóstica' },
        { codigo: '02', nombre: 'Confirmado nuevo' },
        { codigo: '03', nombre: 'Confirmado repetido' },
    ];

    const tiposTecnologiaMedicamento = [
        { codigo: '02', nombre: 'Medicamento con registro sanitario' },
        { codigo: '03', nombre: 'Medicamento vital no disponible' },
        { codigo: '04', nombre: 'Preparación magistral' },
        { codigo: '05', nombre: 'Medicamento UNIRS' },
    ];

    const unidadesMedidaDosis = [
        { codigo: 'mg', nombre: 'Miligramos' },
        { codigo: 'g', nombre: 'Gramos' },
        { codigo: 'ml', nombre: 'Mililitros' },
        { codigo: 'UI', nombre: 'Unidades Internacionales' },
        { codigo: 'mcg', nombre: 'Microgramos' },
    ];

    const viasAdministracion = [
        { codigo: '1', nombre: 'Oral' },
        { codigo: '2', nombre: 'Sublingual' },
        { codigo: '3', nombre: 'Tópica' },
        { codigo: '4', nombre: 'Transdérmica' },
        { codigo: '5', nombre: 'Oftálmica' },
        { codigo: '6', nombre: 'Ótica' },
        { codigo: '7', nombre: 'Nasal' },
        { codigo: '8', nombre: 'Inhalatoria' },
        { codigo: '9', nombre: 'Rectal' },
        { codigo: '10', nombre: 'Vaginal' },
        { codigo: '11', nombre: 'Parenteral' },
        { codigo: '12', nombre: 'Intramuscular' },
        { codigo: '13', nombre: 'Subcutánea' },
        { codigo: '14', nombre: 'Intravenosa' },
        { codigo: '15', nombre: 'Intradérmica' },
    ];

    const unidadesTiempo = [
        { codigo: '1', nombre: 'Minutos' },
        { codigo: '2', nombre: 'Horas' },
        { codigo: '3', nombre: 'Día' },
        { codigo: '4', nombre: 'Semanas' },
        { codigo: '5', nombre: 'Mes' },
        { codigo: '6', nombre: 'Año' },
        { codigo: '7', nombre: 'Según respuesta al tratamiento' },
    ];

    const tiposTecnologiaOtra = [
        { codigo: '06', nombre: 'Dispositivo médico' },
        { codigo: '07', nombre: 'Componentes sanguíneos' },
        { codigo: '08', nombre: 'Fluidos orgánicos' },
        { codigo: '09', nombre: 'Órganos' },
        { codigo: '10', nombre: 'Tejidos' },
        { codigo: '11', nombre: 'Células' },
        { codigo: '12', nombre: 'Producto Soporte Nutricional' },
        { codigo: '13', nombre: 'Servicio complementario' },
    ];

    const alcancesIncapacidad = [
        { codigo: '01', nombre: 'Nueva' },
        { codigo: '02', nombre: 'Prórroga' },
    ];

    // ========== CARGAR DATOS INICIALES ==========
    const cargarDatos = useCallback(async () => {
        setLoading(true);
        try {
            const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
            const config = { headers: { Authorization: 'Bearer ' + userdata.access_token } };

            // Cargar datos del paciente
            if (pacienteIdParam) {
                const resPaciente = await axios.get('/paciente', { ...config, params: { id: pacienteIdParam } });
                const datosPaciente = Array.isArray(resPaciente.data) ? resPaciente.data[0] : resPaciente.data;
                if (datosPaciente) {
                    setPaciente(datosPaciente);
                    setTipoDocumento(datosPaciente.tipo_documento || '');
                    setNumeroDocumento(datosPaciente.numero_documento || '');
                    setPrimerApellido(datosPaciente.primer_apellido || '');
                    setSegundoApellido(datosPaciente.segundo_apellido || '');
                    setPrimerNombre(datosPaciente.primer_nombre || '');
                    setSegundoNombre(datosPaciente.segundo_nombre || '');
                    setFechaNacimiento(datosPaciente.fecha_nacimiento || '');
                    setSexoBiologico(datosPaciente.sexo || '');
                    setCodigoMunicipioResidencia(datosPaciente.codigo_municipio || '');
                    setNombreMunicipioResidencia(datosPaciente.municipio || '');
                    setCodigoEps(datosPaciente.codigo_eps || '');
                    setNombreEps(datosPaciente.eps || '');
                }
            }

            // Cargar datos de la evolución si existe
            if (evolucionIdParam) {
                try {
                    const resEvolucion = await axios.get(`/evolucion/${evolucionIdParam}`, config);
                    if (resEvolucion.data) {
                        setEvolucion(resEvolucion.data);
                    }
                } catch (err) {
                    console.log('No se pudo cargar la evolución:', err);
                }
            }

            // Cargar configuración RDA del usuario
            try {
                const resConfig = await axios.get(`/interop-user-configs/${userdata.user_id}`, config);
                if (resConfig.data) {
                    setUserConfig(resConfig.data);
                    setCodigoPrestador(resConfig.data.reps_code || '');
                }
            } catch (err) {
                console.log('No se pudo cargar configuración RDA:', err);
            }

            // Cargar datos del profesional (usuario actual)
            if (userdata) {
                setTipoDocumentoProfesional(userdata.tipo_documento || 'CC');
                setNumeroDocumentoProfesional(userdata.numero_documento || '');
            }

            // Establecer fecha/hora actual
            const ahora = new Date();
            const fechaHoraStr = ahora.toISOString().slice(0, 16);
            setFechaHoraInicio(fechaHoraStr);
            setFechaHoraFin(fechaHoraStr);

        } catch (error) {
            console.error('Error cargando datos:', error);
            Swal.fire('Error', 'No se pudieron cargar los datos necesarios', 'error');
        } finally {
            setLoading(false);
        }
    }, [pacienteIdParam, evolucionIdParam]);

    useEffect(() => {
        cargarDatos();
    }, [cargarDatos]);

    // ========== FUNCIONES AUXILIARES ==========
    const agregarAlergia = () => {
        if (nuevaAlergiaTipo && nuevaAlergiaNombre) {
            setAlergias([...alergias, { tipo: nuevaAlergiaTipo, nombre: nuevaAlergiaNombre }]);
            setNuevaAlergiaTipo('');
            setNuevaAlergiaNombre('');
        }
    };

    const eliminarAlergia = (index) => {
        setAlergias(alergias.filter((_, i) => i !== index));
    };

    const agregarFactorRiesgo = () => {
        if (nuevoFactorTipo && nuevoFactorNombre) {
            setFactoresRiesgo([...factoresRiesgo, { tipo: nuevoFactorTipo, nombre: nuevoFactorNombre }]);
            setNuevoFactorTipo('');
            setNuevoFactorNombre('');
        }
    };

    const eliminarFactorRiesgo = (index) => {
        setFactoresRiesgo(factoresRiesgo.filter((_, i) => i !== index));
    };

    const agregarDiagnosticoRelacionado = () => {
        setDiagnosticosRelacionados([...diagnosticosRelacionados, { 
            codigoCie10: '', 
            nombreCie10: '', 
            codigoCie11: '', 
            terminoCie11: '' 
        }]);
    };

    const actualizarDiagnosticoRelacionado = (index, campo, valor) => {
        const nuevos = [...diagnosticosRelacionados];
        nuevos[index][campo] = valor;
        setDiagnosticosRelacionados(nuevos);
    };

    const eliminarDiagnosticoRelacionado = (index) => {
        setDiagnosticosRelacionados(diagnosticosRelacionados.filter((_, i) => i !== index));
    };

    const agregarMedicamento = () => {
        setMedicamentos([...medicamentos, {
            tipoTecnologia: '02',
            codigo: '',
            nombre: '',
            descripcion: '',
            fechaPrescripcion: new Date().toISOString().slice(0, 10),
            dosis: '',
            unidadMedidaDosis: '',
            viaAdministracion: '',
            duracionCantidad: '',
            duracionUnidad: '',
            frecuenciaCantidad: '',
            frecuenciaUnidad: '',
            finalidad: '',
        }]);
    };

    const actualizarMedicamento = (index, campo, valor) => {
        const nuevos = [...medicamentos];
        nuevos[index][campo] = valor;
        setMedicamentos(nuevos);
    };

    const eliminarMedicamento = (index) => {
        setMedicamentos(medicamentos.filter((_, i) => i !== index));
    };

    const agregarProcedimiento = () => {
        setProcedimientos([...procedimientos, {
            codigo: '',
            nombre: '',
            finalidad: '',
            fechaPrescripcion: new Date().toISOString().slice(0, 10),
        }]);
    };

    const actualizarProcedimiento = (index, campo, valor) => {
        const nuevos = [...procedimientos];
        nuevos[index][campo] = valor;
        setProcedimientos(nuevos);
    };

    const eliminarProcedimiento = (index) => {
        setProcedimientos(procedimientos.filter((_, i) => i !== index));
    };

    const agregarOtraTecnologia = () => {
        setOtrasTecnologias([...otrasTecnologias, {
            tipoTecnologia: '06',
            codigo: '',
            nombre: '',
            fechaPrescripcion: new Date().toISOString().slice(0, 10),
            finalidad: '',
        }]);
    };

    const actualizarOtraTecnologia = (index, campo, valor) => {
        const nuevos = [...otrasTecnologias];
        nuevos[index][campo] = valor;
        setOtrasTecnologias(nuevos);
    };

    const eliminarOtraTecnologia = (index) => {
        setOtrasTecnologias(otrasTecnologias.filter((_, i) => i !== index));
    };

    // ========== ENVIAR FORMULARIO ==========
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!codigoPrestador) {
            Swal.fire('Error', 'Debe configurar el código REPS en Parámetros RDA antes de generar un RDA', 'error');
            return;
        }

        if (!diagnosticoPrincipalCie10) {
            Swal.fire('Error', 'Debe ingresar al menos el diagnóstico principal CIE-10', 'error');
            return;
        }

        setSubmitting(true);

        try {
            const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
            const config = { headers: { Authorization: 'Bearer ' + userdata.access_token } };

            const payload = {
                paciente_id: pacienteIdParam,
                evolucion_id: evolucionIdParam || null,
                
                // Prestador
                codigo_prestador: codigoPrestador,
                
                // EPS
                codigo_eps: codigoEps,
                nombre_eps: nombreEps,
                
                // Paciente
                tipo_documento: tipoDocumento,
                numero_documento: numeroDocumento,
                primer_apellido: primerApellido,
                segundo_apellido: segundoApellido,
                primer_nombre: primerNombre,
                segundo_nombre: segundoNombre,
                fecha_nacimiento: fechaNacimiento,
                codigo_pais_nacionalidad: codigoPaisNacionalidad,
                nombre_pais_nacionalidad: nombrePaisNacionalidad,
                sexo_biologico: sexoBiologico,
                identidad_genero: identidadGenero,
                etnia: etnia,
                comunidad_etnica: comunidadEtnica,
                categoria_discapacidad: categoriaDiscapacidad,
                codigo_ocupacion: codigoOcupacion,
                nombre_ocupacion: nombreOcupacion,
                codigo_pais_residencia: codigoPaisResidencia,
                nombre_pais_residencia: nombrePaisResidencia,
                codigo_municipio_residencia: codigoMunicipioResidencia,
                nombre_municipio_residencia: nombreMunicipioResidencia,
                zona_residencia: zonaResidencia,
                
                // Consulta
                fecha_hora_inicio: fechaHoraInicio,
                fecha_hora_fin: fechaHoraFin,
                modalidad_atencion: modalidadAtencion,
                grupo_servicios: grupoServicios,
                entorno_atencion: entornoAtencion,
                via_ingreso: viaIngreso,
                causa_atencion: causaAtencion,
                
                // Antecedentes
                alergias: alergias,
                factores_riesgo: factoresRiesgo,
                antecedente_familiar_cie10: antecedenteFamiliarCie10,
                antecedente_familiar_cie11: antecedenteFamiliarCie11,
                parentesco_antecedente: parentescoAntecedente,
                
                // Diagnósticos
                diagnostico_principal_cie10: diagnosticoPrincipalCie10,
                nombre_diagnostico_principal: nombreDiagnosticoPrincipal,
                tipo_diagnostico_principal: tipoDiagnosticoPrincipal,
                diagnostico_principal_cie11: diagnosticoPrincipalCie11,
                termino_diagnostico_cie11: terminoDiagnosticoCie11,
                diagnosticos_relacionados: diagnosticosRelacionados,
                condicion_destino: condicionDestino,
                codigo_prestador_remision: codigoPrestadorRemision,
                
                // Tecnologías
                medicamentos: medicamentos,
                procedimientos: procedimientos,
                otras_tecnologias: otrasTecnologias,
                
                // Incapacidad
                alcance_incapacidad: alcanceIncapacidad,
                dias_incapacidad: diasIncapacidad,
                dias_licencia_maternidad: diasLicenciaMaternidad,
                
                // Profesional
                tipo_documento_profesional: tipoDocumentoProfesional,
                numero_documento_profesional: numeroDocumentoProfesional,
            };

            const response = await axios.post('/rda-consulta-externa', payload, config);

            if (response.data?.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'RDA Guardado',
                    text: response.data.message || 'El RDA de consulta externa se ha guardado correctamente',
                    showConfirmButton: true,
                }).then(() => {
                    history.goBack();
                });
            } else {
                throw new Error(response.data?.message || 'Error al guardar RDA');
            }

        } catch (error) {
            console.error('Error guardando RDA:', error);
            Swal.fire('Error', error.response?.data?.message || 'No se pudo guardar el RDA', 'error');
        } finally {
            setSubmitting(false);
        }
    };

    // ========== RENDERIZADO ==========
    if (loading) {
        return (
            <>
                <Header />
                <Aside activelink="patients" />
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid pt-4">
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-3x"></i>
                                <p className="mt-3">Cargando datos...</p>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </>
        );
    }

    const nombreCompletoPaciente = paciente 
        ? `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.replace(/\s+/g, ' ').trim()
        : 'Paciente';

    return (
        <>
            <Header />
            <Aside activelink="patients" />

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1><i className="fas fa-file-export text-success"></i> RDA Consulta Externa</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><Link to="/home">Inicio</Link></li>
                                    <li className="breadcrumb-item"><Link to="/pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item"><Link to={`/evolucion-paciente?id=${pacienteIdParam}`}>Evolución</Link></li>
                                    <li className="breadcrumb-item active">RDA Consulta Externa</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        
                        {/* Alerta si no tiene configuración RDA */}
                        {!userConfig?.reps_code && (
                            <div className="alert alert-warning">
                                <i className="fas fa-exclamation-triangle"></i> <strong>Atención:</strong> No tiene configurado el código REPS. 
                                <Link to="/parametros-rda" className="ml-2">Configurar Parámetros RDA</Link>
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            
                            {/* ========== SECCIÓN: PRESTADOR ========== */}
                            <div className="card card-outline card-dark">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionPrestador(!seccionPrestador)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-hospital"></i> Identificación del Prestador
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionPrestador ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionPrestador && (
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Código REPS del Prestador <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={codigoPrestador}
                                                        onChange={(e) => setCodigoPrestador(e.target.value)}
                                                        placeholder="Código de habilitación REPS"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: PACIENTE ========== */}
                            <div className="card card-outline card-primary">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionPaciente(!seccionPaciente)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-user"></i> Identificación del Paciente: {nombreCompletoPaciente}
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionPaciente ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionPaciente && (
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Tipo Documento</label>
                                                    <select className="form-control" value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>
                                                        <option value="">Seleccione...</option>
                                                        {tiposDocumento.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Número Documento</label>
                                                    <input type="text" className="form-control" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Primer Apellido</label>
                                                    <input type="text" className="form-control" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Segundo Apellido</label>
                                                    <input type="text" className="form-control" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Primer Nombre</label>
                                                    <input type="text" className="form-control" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Segundo Nombre</label>
                                                    <input type="text" className="form-control" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Fecha Nacimiento</label>
                                                    <input type="date" className="form-control" value={fechaNacimiento} onChange={(e) => setFechaNacimiento(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Sexo Biológico</label>
                                                    <select className="form-control" value={sexoBiologico} onChange={(e) => setSexoBiologico(e.target.value)}>
                                                        <option value="">Seleccione...</option>
                                                        {sexosBiologicos.map(s => <option key={s.codigo} value={s.codigo}>{s.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Código EPS</label>
                                                    <input type="text" className="form-control" value={codigoEps} onChange={(e) => setCodigoEps(e.target.value)} placeholder="Código administrador plan beneficios" />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Nombre EPS</label>
                                                    <input type="text" className="form-control" value={nombreEps} onChange={(e) => setNombreEps(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Municipio Residencia</label>
                                                    <input type="text" className="form-control" value={nombreMunicipioResidencia} onChange={(e) => setNombreMunicipioResidencia(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: DATOS DE LA CONSULTA ========== */}
                            <div className="card card-outline card-info">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionConsulta(!seccionConsulta)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-stethoscope"></i> Datos de la Consulta Externa
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionConsulta ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionConsulta && (
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Fecha/Hora Inicio <span className="text-danger">*</span></label>
                                                    <input type="datetime-local" className="form-control" value={fechaHoraInicio} onChange={(e) => setFechaHoraInicio(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Fecha/Hora Fin <span className="text-danger">*</span></label>
                                                    <input type="datetime-local" className="form-control" value={fechaHoraFin} onChange={(e) => setFechaHoraFin(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Modalidad Atención <span className="text-danger">*</span></label>
                                                    <select className="form-control" value={modalidadAtencion} onChange={(e) => setModalidadAtencion(e.target.value)} required>
                                                        {modalidadesAtencion.map(m => <option key={m.codigo} value={m.codigo}>{m.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Entorno Atención <span className="text-danger">*</span></label>
                                                    <select className="form-control" value={entornoAtencion} onChange={(e) => setEntornoAtencion(e.target.value)} required>
                                                        {entornosAtencion.map(e => <option key={e.codigo} value={e.codigo}>{e.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Grupo de Servicios</label>
                                                    <input type="text" className="form-control" value="01 - Consulta Externa" disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Vía de Ingreso</label>
                                                    <input type="text" className="form-control" value={viaIngreso} onChange={(e) => setViaIngreso(e.target.value)} placeholder="Código vía ingreso" />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Causa que Motiva la Atención</label>
                                                    <input type="text" className="form-control" value={causaAtencion} onChange={(e) => setCausaAtencion(e.target.value)} placeholder="Código causa RIPS" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: ANTECEDENTES ========== */}
                            <div className="card card-outline card-warning">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionAntecedentes(!seccionAntecedentes)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-history"></i> Antecedentes de Salud (Opcional)
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionAntecedentes ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionAntecedentes && (
                                    <div className="card-body">
                                        {/* Alergias */}
                                        <h5><i className="fas fa-allergies text-danger"></i> Alergias</h5>
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <select className="form-control" value={nuevaAlergiaTipo} onChange={(e) => setNuevaAlergiaTipo(e.target.value)}>
                                                    <option value="">Tipo de alergia...</option>
                                                    {tiposAlergia.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-5">
                                                <input type="text" className="form-control" placeholder="Nombre del alérgeno" value={nuevaAlergiaNombre} onChange={(e) => setNuevaAlergiaNombre(e.target.value)} />
                                            </div>
                                            <div className="col-md-3">
                                                <button type="button" className="btn btn-success btn-block" onClick={agregarAlergia}>
                                                    <i className="fas fa-plus"></i> Agregar
                                                </button>
                                            </div>
                                        </div>
                                        {alergias.length > 0 && (
                                            <table className="table table-sm table-bordered mb-4">
                                                <thead className="thead-light">
                                                    <tr><th>Tipo</th><th>Nombre</th><th style={{width: '60px'}}></th></tr>
                                                </thead>
                                                <tbody>
                                                    {alergias.map((a, i) => (
                                                        <tr key={i}>
                                                            <td>{tiposAlergia.find(t => t.codigo === a.tipo)?.nombre || a.tipo}</td>
                                                            <td>{a.nombre}</td>
                                                            <td><button type="button" className="btn btn-danger btn-xs" onClick={() => eliminarAlergia(i)}><i className="fas fa-trash"></i></button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}

                                        {/* Factores de Riesgo */}
                                        <h5><i className="fas fa-exclamation-triangle text-warning"></i> Factores de Riesgo</h5>
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <select className="form-control" value={nuevoFactorTipo} onChange={(e) => setNuevoFactorTipo(e.target.value)}>
                                                    <option value="">Tipo de factor...</option>
                                                    {tiposFactorRiesgo.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-5">
                                                <input type="text" className="form-control" placeholder="Nombre del factor" value={nuevoFactorNombre} onChange={(e) => setNuevoFactorNombre(e.target.value)} />
                                            </div>
                                            <div className="col-md-3">
                                                <button type="button" className="btn btn-success btn-block" onClick={agregarFactorRiesgo}>
                                                    <i className="fas fa-plus"></i> Agregar
                                                </button>
                                            </div>
                                        </div>
                                        {factoresRiesgo.length > 0 && (
                                            <table className="table table-sm table-bordered">
                                                <thead className="thead-light">
                                                    <tr><th>Tipo</th><th>Nombre</th><th style={{width: '60px'}}></th></tr>
                                                </thead>
                                                <tbody>
                                                    {factoresRiesgo.map((f, i) => (
                                                        <tr key={i}>
                                                            <td>{tiposFactorRiesgo.find(t => t.codigo === f.tipo)?.nombre || f.tipo}</td>
                                                            <td>{f.nombre}</td>
                                                            <td><button type="button" className="btn btn-danger btn-xs" onClick={() => eliminarFactorRiesgo(i)}><i className="fas fa-trash"></i></button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: DIAGNÓSTICOS ========== */}
                            <div className="card card-outline card-danger">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionDiagnosticos(!seccionDiagnosticos)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-diagnoses"></i> Diagnósticos <span className="text-danger">*</span>
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionDiagnosticos ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionDiagnosticos && (
                                    <div className="card-body">
                                        <h5>Diagnóstico Principal</h5>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Código CIE-10 <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control" value={diagnosticoPrincipalCie10} onChange={(e) => setDiagnosticoPrincipalCie10(e.target.value)} placeholder="Ej: K021" required />
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label>Nombre Diagnóstico</label>
                                                    <input type="text" className="form-control" value={nombreDiagnosticoPrincipal} onChange={(e) => setNombreDiagnosticoPrincipal(e.target.value)} placeholder="Nombre del diagnóstico" />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Tipo Diagnóstico</label>
                                                    <select className="form-control" value={tipoDiagnosticoPrincipal} onChange={(e) => setTipoDiagnosticoPrincipal(e.target.value)}>
                                                        {tiposDiagnostico.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Código CIE-11 (Opcional)</label>
                                                    <input type="text" className="form-control" value={diagnosticoPrincipalCie11} onChange={(e) => setDiagnosticoPrincipalCie11(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label>Término CIE-11</label>
                                                    <input type="text" className="form-control" value={terminoDiagnosticoCie11} onChange={(e) => setTerminoDiagnosticoCie11(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Condición y Destino al Egreso</label>
                                                    <input type="text" className="form-control" value={condicionDestino} onChange={(e) => setCondicionDestino(e.target.value)} placeholder="Código condición destino" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr />
                                        <h5>Diagnósticos Relacionados 
                                            <button type="button" className="btn btn-sm btn-outline-primary ml-2" onClick={agregarDiagnosticoRelacionado}>
                                                <i className="fas fa-plus"></i> Agregar
                                            </button>
                                        </h5>
                                        {diagnosticosRelacionados.map((dx, i) => (
                                            <div key={i} className="row mb-2 p-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                                <div className="col-md-3">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Código CIE-10" value={dx.codigoCie10} onChange={(e) => actualizarDiagnosticoRelacionado(i, 'codigoCie10', e.target.value)} />
                                                </div>
                                                <div className="col-md-4">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Nombre CIE-10" value={dx.nombreCie10} onChange={(e) => actualizarDiagnosticoRelacionado(i, 'nombreCie10', e.target.value)} />
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="text" className="form-control form-control-sm" placeholder="CIE-11" value={dx.codigoCie11} onChange={(e) => actualizarDiagnosticoRelacionado(i, 'codigoCie11', e.target.value)} />
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Término CIE-11" value={dx.terminoCie11} onChange={(e) => actualizarDiagnosticoRelacionado(i, 'terminoCie11', e.target.value)} />
                                                </div>
                                                <div className="col-md-1">
                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => eliminarDiagnosticoRelacionado(i)}><i className="fas fa-trash"></i></button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: MEDICAMENTOS ========== */}
                            <div className="card card-outline card-success">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionMedicamentos(!seccionMedicamentos)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-pills"></i> Fórmula de Medicamentos ({medicamentos.length})
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionMedicamentos ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionMedicamentos && (
                                    <div className="card-body">
                                        <button type="button" className="btn btn-success mb-3" onClick={agregarMedicamento}>
                                            <i className="fas fa-plus"></i> Agregar Medicamento
                                        </button>
                                        {medicamentos.map((med, i) => (
                                            <div key={i} className="card mb-2">
                                                <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                                    <span><strong>Medicamento #{i + 1}</strong></span>
                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => eliminarMedicamento(i)}><i className="fas fa-trash"></i></button>
                                                </div>
                                                <div className="card-body py-2">
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <label className="small">Tipo Tecnología</label>
                                                            <select className="form-control form-control-sm" value={med.tipoTecnologia} onChange={(e) => actualizarMedicamento(i, 'tipoTecnologia', e.target.value)}>
                                                                {tiposTecnologiaMedicamento.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label className="small">Código CUM</label>
                                                            <input type="text" className="form-control form-control-sm" value={med.codigo} onChange={(e) => actualizarMedicamento(i, 'codigo', e.target.value)} />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label className="small">Nombre</label>
                                                            <input type="text" className="form-control form-control-sm" value={med.nombre} onChange={(e) => actualizarMedicamento(i, 'nombre', e.target.value)} />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label className="small">Fecha Prescripción</label>
                                                            <input type="date" className="form-control form-control-sm" value={med.fechaPrescripcion} onChange={(e) => actualizarMedicamento(i, 'fechaPrescripcion', e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-2">
                                                            <label className="small">Dosis</label>
                                                            <input type="number" className="form-control form-control-sm" value={med.dosis} onChange={(e) => actualizarMedicamento(i, 'dosis', e.target.value)} />
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label className="small">Unidad</label>
                                                            <select className="form-control form-control-sm" value={med.unidadMedidaDosis} onChange={(e) => actualizarMedicamento(i, 'unidadMedidaDosis', e.target.value)}>
                                                                <option value="">...</option>
                                                                {unidadesMedidaDosis.map(u => <option key={u.codigo} value={u.codigo}>{u.nombre}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label className="small">Vía Admin.</label>
                                                            <select className="form-control form-control-sm" value={med.viaAdministracion} onChange={(e) => actualizarMedicamento(i, 'viaAdministracion', e.target.value)}>
                                                                <option value="">...</option>
                                                                {viasAdministracion.map(v => <option key={v.codigo} value={v.codigo}>{v.nombre}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label className="small">Duración</label>
                                                            <div className="input-group input-group-sm">
                                                                <input type="number" className="form-control" value={med.duracionCantidad} onChange={(e) => actualizarMedicamento(i, 'duracionCantidad', e.target.value)} />
                                                                <select className="form-control" value={med.duracionUnidad} onChange={(e) => actualizarMedicamento(i, 'duracionUnidad', e.target.value)}>
                                                                    <option value="">...</option>
                                                                    {unidadesTiempo.map(u => <option key={u.codigo} value={u.codigo}>{u.nombre}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label className="small">Frecuencia</label>
                                                            <div className="input-group input-group-sm">
                                                                <input type="number" className="form-control" value={med.frecuenciaCantidad} onChange={(e) => actualizarMedicamento(i, 'frecuenciaCantidad', e.target.value)} />
                                                                <select className="form-control" value={med.frecuenciaUnidad} onChange={(e) => actualizarMedicamento(i, 'frecuenciaUnidad', e.target.value)}>
                                                                    <option value="">...</option>
                                                                    {unidadesTiempo.map(u => <option key={u.codigo} value={u.codigo}>{u.nombre}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <label className="small">Finalidad</label>
                                                            <input type="text" className="form-control form-control-sm" value={med.finalidad} onChange={(e) => actualizarMedicamento(i, 'finalidad', e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: PROCEDIMIENTOS ========== */}
                            <div className="card card-outline card-purple">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionProcedimientos(!seccionProcedimientos)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-procedures"></i> Procedimientos Ordenados ({procedimientos.length})
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionProcedimientos ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionProcedimientos && (
                                    <div className="card-body">
                                        <button type="button" className="btn btn-purple mb-3" style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1', color: '#fff' }} onClick={agregarProcedimiento}>
                                            <i className="fas fa-plus"></i> Agregar Procedimiento
                                        </button>
                                        {procedimientos.map((proc, i) => (
                                            <div key={i} className="row mb-2 p-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                                <div className="col-md-3">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Código CUPS" value={proc.codigo} onChange={(e) => actualizarProcedimiento(i, 'codigo', e.target.value)} />
                                                </div>
                                                <div className="col-md-4">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Nombre procedimiento" value={proc.nombre} onChange={(e) => actualizarProcedimiento(i, 'nombre', e.target.value)} />
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Finalidad" value={proc.finalidad} onChange={(e) => actualizarProcedimiento(i, 'finalidad', e.target.value)} />
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="date" className="form-control form-control-sm" value={proc.fechaPrescripcion} onChange={(e) => actualizarProcedimiento(i, 'fechaPrescripcion', e.target.value)} />
                                                </div>
                                                <div className="col-md-1">
                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => eliminarProcedimiento(i)}><i className="fas fa-trash"></i></button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: OTRAS TECNOLOGÍAS ========== */}
                            <div className="card card-outline card-secondary">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionOtrasTecnologias(!seccionOtrasTecnologias)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-cogs"></i> Otras Tecnologías en Salud ({otrasTecnologias.length})
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionOtrasTecnologias ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionOtrasTecnologias && (
                                    <div className="card-body">
                                        <button type="button" className="btn btn-secondary mb-3" onClick={agregarOtraTecnologia}>
                                            <i className="fas fa-plus"></i> Agregar Tecnología
                                        </button>
                                        {otrasTecnologias.map((tec, i) => (
                                            <div key={i} className="row mb-2 p-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                                <div className="col-md-3">
                                                    <select className="form-control form-control-sm" value={tec.tipoTecnologia} onChange={(e) => actualizarOtraTecnologia(i, 'tipoTecnologia', e.target.value)}>
                                                        {tiposTecnologiaOtra.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Código" value={tec.codigo} onChange={(e) => actualizarOtraTecnologia(i, 'codigo', e.target.value)} />
                                                </div>
                                                <div className="col-md-3">
                                                    <input type="text" className="form-control form-control-sm" placeholder="Nombre" value={tec.nombre} onChange={(e) => actualizarOtraTecnologia(i, 'nombre', e.target.value)} />
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="date" className="form-control form-control-sm" value={tec.fechaPrescripcion} onChange={(e) => actualizarOtraTecnologia(i, 'fechaPrescripcion', e.target.value)} />
                                                </div>
                                                <div className="col-md-1">
                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => eliminarOtraTecnologia(i)}><i className="fas fa-trash"></i></button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: INCAPACIDAD ========== */}
                            <div className="card card-outline card-orange">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionIncapacidad(!seccionIncapacidad)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-user-injured"></i> Datos de Incapacidad (Opcional)
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionIncapacidad ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionIncapacidad && (
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Alcance de la Incapacidad</label>
                                                    <select className="form-control" value={alcanceIncapacidad} onChange={(e) => setAlcanceIncapacidad(e.target.value)}>
                                                        <option value="">No aplica</option>
                                                        {alcancesIncapacidad.map(a => <option key={a.codigo} value={a.codigo}>{a.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Días de Incapacidad</label>
                                                    <input type="number" className="form-control" value={diasIncapacidad} onChange={(e) => setDiasIncapacidad(e.target.value)} min="0" />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Días Licencia Maternidad</label>
                                                    <input type="number" className="form-control" value={diasLicenciaMaternidad} onChange={(e) => setDiasLicenciaMaternidad(e.target.value)} min="0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ========== SECCIÓN: PROFESIONAL ========== */}
                            <div className="card card-outline card-teal">
                                <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setSeccionProfesional(!seccionProfesional)}>
                                    <h3 className="card-title">
                                        <i className="fas fa-user-md"></i> Profesional de Salud
                                    </h3>
                                    <div className="card-tools">
                                        <i className={`fas fa-chevron-${seccionProfesional ? 'up' : 'down'}`}></i>
                                    </div>
                                </div>
                                {seccionProfesional && (
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Tipo Documento Profesional</label>
                                                    <select className="form-control" value={tipoDocumentoProfesional} onChange={(e) => setTipoDocumentoProfesional(e.target.value)}>
                                                        <option value="">Seleccione...</option>
                                                        {tiposDocumento.map(t => <option key={t.codigo} value={t.codigo}>{t.nombre}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Número Documento Profesional</label>
                                                    <input type="text" className="form-control" value={numeroDocumentoProfesional} onChange={(e) => setNumeroDocumentoProfesional(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ========== BOTONES DE ACCIÓN ========== */}
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="button" className="btn btn-secondary btn-block" onClick={() => history.goBack()}>
                                                <i className="fas fa-arrow-left"></i> Cancelar
                                            </button>
                                        </div>
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-success btn-block" disabled={submitting}>
                                                {submitting ? (
                                                    <><i className="fas fa-spinner fa-spin"></i> Guardando...</>
                                                ) : (
                                                    <><i className="fas fa-save"></i> Guardar RDA</>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>
                </section>
            </div>

            <Footer />
        </>
    );
}

export default CrearRDAExterna;
